import { onMounted, onUnmounted, ref, reactive } from 'vue';

export function useAnimations() {
  const animatedRefs = reactive({}); // Objeto para referencias dinámicas
  let lastScrollTop = 0; // Variable para almacenar la posición anterior del scroll

  const animationClasses = {
    FadeIn: 'animate__fadeIn',
    FadeInUp: 'animate__fadeInUp',
    FadeInDown: 'animate__fadeInDown',
    FadeInLeft: 'animate__fadeInLeft',
    FadeInRight: 'animate__fadeInRight'
  };

  const animateElement = (el, direction) => {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    el.dataset.primeraVez = true;
    const elementHeight = rect.height;
    const elementVisibleHeight = Math.min(windowHeight, rect.bottom) - Math.max(0, rect.top);
    const visibility = elementVisibleHeight / elementHeight;

    const multiplier = direction ? 100 : -100;

    if (visibility > 0 && visibility <= 0.99 && el.dataset.primeraVez) {
      el.style.transform = `translateX(${(0.99 - visibility) * multiplier}%)`;
      el.style.opacity = visibility;
    } 
    if (visibility > 0 && visibility <= 0.99 && !el.dataset.primeraVez) {
      el.style.transform = `translateX(${(0.99 - visibility) * multiplier}%)`;
      el.style.opacity = visibility;
    } 
    if (visibility > 0.81 && visibility <= 1) {
      el.style.transform = `translateX(0)`;
      el.style.opacity = 1;
      el.dataset.animated = !el.dataset.primeraVez; // Marcar el elemento como animado y desaparecido
    }
  };

  const handleScroll = () => {
    const elements = document.querySelectorAll('[data-animation="IzqADer"]');
    elements.forEach(el => animateElement(el, false));

    const elementsRightToLeft = document.querySelectorAll('[data-animation="DerAIzq"]');
    elementsRightToLeft.forEach(el => animateElement(el, true));
  };

  onMounted(() => {
    const elements = document.querySelectorAll('[data-animation]');
    const animationCount = {};

    elements.forEach(el => {
      const animationType = el.dataset.animation;
      const duration = el.dataset.duration || "1s"; // Duración de la animación
      const delay = parseFloat(el.dataset.delay) || 0; // Retraso en segundos

      if (animationType !== 'IzqADer' && animationType !== 'DerAIzq') {
        if (!animationCount[animationType]) {
          animationCount[animationType] = 0;
        }

        animationCount[animationType]++;
        const refName = `${animationType}${animationCount[animationType]}`;
        animatedRefs[refName] = ref(el);

        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const animationClass = animationClasses[animationType] || 'animate__fadeInUp';

                setTimeout(() => {
                  entry.target.classList.add('animate__animated', animationClass);
                  entry.target.style.setProperty('--animation-duration', duration);
                  observer.unobserve(entry.target);
                }, delay * 1000); // Convertir segundos a milisegundos
              }
            });
          },
          {
            root: null,
            threshold: 0.3
          }
        );

        observer.observe(el);
      }
    });

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Ejecutar una vez al montar para animar elementos visibles
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  return {
    ...animatedRefs
  };
}